export default __webpack_public_path__ + "static/media/writing.2de002ba.png";